/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-alert */
import React, {useContext, useEffect} from 'react';
import brand from '../../../branding';

import AppStateContext from "../../context/appStateContext";

import LogAJobForm from '../../components/logAJobForm';
import PageHeader from '../../components/pageHeader';
import PageLayout from '../../components/pageLayout';

import ICONS from '../../../assets/icons';
import THEME from '../../../assets/styles/config';
import HeaderImg from '../../../assets/images/headerImages/logAJob_header.png';

import {
  PageCtn,
  InfoBoxContent,
  InfoBoxCtn,
  PageHeaderText,
  ParagraphSection,
  AccessMessage,
  ResponseTable,
  TableHead,
  TableCell,
  TableRow,
} from './index.style';

const LogAJob: React.FC<any> = (...restProps): React.ReactElement => {

  const { customerInfoMap, selectedCustomerId, userPermissionsList, contractCriticalCode, callTime, defaultNumber, siteLogo, contactEmail } = useContext(AppStateContext);

  const customerNumber = customerInfoMap[selectedCustomerId].number != undefined? customerInfoMap[selectedCustomerId].number : defaultNumber;

  return (
    <PageLayout>
      <PageHeader backgroundImg={(brand.heroImages && brand.heroImages['logAJob']) || brand.heroImage || siteLogo.background_image[1]['image']['url']}>
        <PageHeaderText>Log a job</PageHeaderText>
        <div />
      </PageHeader>
      <PageCtn>
        {userPermissionsList.includes('log-a-job')? <React.Fragment>
          <InfoBoxCtn>
            <InfoBoxContent>
              <ParagraphSection>
                <div>
                  <ICONS.user />
                </div>
                <p>
                  You are logged in to the&nbsp;
                  <b>{customerInfoMap[selectedCustomerId].CustomerName}</b> site, if you wish to change the site that you are logging the call for, please
                  select the correct site by switching site.
                </p>
              </ParagraphSection>
              <ParagraphSection>
                <div>
                  <ICONS.clock />
                </div>
                <p>
                  Any calls logged outside of usual Business Hours (Monday to Friday {callTime})
                  <b> will not be responded to until the following business day. </b>
                </p>
              </ParagraphSection>
              <ParagraphSection>
                <div>
                  <ICONS.user />
                </div>
                <p>
                  <b>
                    For requests outside of Business Hours, or for requests of an urgent nature please call {customerNumber}
                  </b>
                </p>
              </ParagraphSection>
            </InfoBoxContent>
          </InfoBoxCtn>
            {window.innerWidth < THEME.layout.desktop.breakpoint && <ResponseTable>
              <TableRow>
                <TableHead>
                  Critical code
                </TableHead>
                <TableHead>
                  Response time
                </TableHead>
              </TableRow>
              {
                Object.values(contractCriticalCode).map( (item, index) => {

                  if(!Object.keys(item).length) return;

                  return <TableRow>
                    <TableCell criticalCode={true}>
                      {item.CriticalCode}
                    </TableCell>
                    <TableCell criticalCode={false}>
                      {item.ResponseTime} hours
                    </TableCell>
                  </TableRow>
                })
              }
            </ResponseTable>}
          <LogAJobForm />
        </React.Fragment>:
          <AccessMessage>
          <ICONS.alertTriangle/>
          <h2>You currently do not have permission to access this page, please contact {contactEmail}</h2>
        </AccessMessage>}
      </PageCtn>
    </PageLayout>
  );
};

export default LogAJob;
